import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import Config from 'config/config.json';

const { contentfulTranslationsPath, contentfulAccessToken } = Config;

const publicPath = contentfulTranslationsPath;
const authToken = contentfulAccessToken;
const defaultConfig = Config.defaultLocale.split('-');
const defaultLocale = defaultConfig[0];
const defaultCountry = defaultConfig[1];

export const getLocaleTag = () => {
    return `${
      defaultLocale.substr(0, 1).toLowerCase()
    }${
      defaultLocale.substr(1, 1).toLowerCase()
    }${
      defaultCountry.substr(0, 1).toUpperCase()
    }${
      defaultCountry.substr(1, 1).toLowerCase()
    }`;
}

i18n
  .use(initReactI18next)
  .use(Backend)
  .init({
    lng: `${defaultLocale}-${defaultCountry.toUpperCase()}`,
    fallbackLng: `${defaultConfig}`,
    backend: {
      loadPath: `${publicPath}`,
      allowMultiLoading: false,
      requestOptions: {
        cache: 'no-store', // ignore cache
      },
      queryStringParams: {
        query: `query{
          translationCollection(where: {
            contentfulMetadata: {
              tags: {
                id_contains_all: "${getLocaleTag()}"
              }
            }
          }){
            items {
              text,
              key
            }
          }
        }`
      },
      parse: function(data){
        const parsedData = JSON.parse(data);
        const items = parsedData?.data?.translationCollection?.items || [];
        let returnData = {};
        items.forEach(item => {
          returnData = Object.assign({}, returnData, {[item.key]: item.text})
        });
        return returnData;
      },
      customHeaders: {
        authorization: `Bearer ${authToken}`,
      },
    },
    load: 'currentOnly',
    keySeparator: false,
    
    // debug: true,

    interpolation: {
      escapeValue: false,
    },

  });

export default i18n;
